//Creates new Cuvette and assigns ID and type
export const createCuvette = (data) => {
    //data = {id, type}
    return { type: "CREATE_CUVETTE", payload: data}
}

export const cuvetteItemDrop = (data) => {
    return { type: "CUVETTE_DROP_ITEM", payload: data}
}

export const cuvetteRemoveItem = (data) => {
    return { type: "CUVETTE_REMOVE_ITEM", payload: data}
}

export const setCuvetteSolution = (data) => {
  return { type: "SET_CUVETTE_SOLUTION", payload: data}
}

//Set if pipette controls are visible or not
export const setCuvetteHeld = (data) => {
  //data = {id, held}
  return { type: "SET_CUVETTE_HELD", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setCuvetteControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_CUVETTE_CONTROLS_VISIBLE", payload: data}
}

export const setCuvettesInScene = data => {
  //data = {type, inScene}
  return { type: "SET_CUVETTE_IN_SCENE", payload: data };
};